import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';
import { shadow, shadowSm } from '../../../web/styles/shadows';

const { fontFamilies, fontSizes, fontWeights } = THEME.typography;

export const styleSheet = StyleSheet.create({
	page: {
		boxSizing: 'border-box',
		margin: '0 auto',
		maxWidth: 1400,
		padding: SPACE[16],
		width: '100%',
	},
	header: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
	},
	content: {
		backgroundColor: THEME.colors.background.light,
		borderRadius: THEME.common.borderRadius,
		boxShadow: shadowSm,
		color: THEME.colors.text.main,
		display: 'flex',
		flexDirection: 'column',
		fontFamily: fontFamilies.lexend,
		gap: SPACE[32],
		padding: SPACE[32],
		[THEME.queries.sm]: {
			padding: SPACE[16],
		},
	},
	title: {
		fontFamily: fontFamilies.sora,
		fontSize: fontSizes.xl,
		fontWeight: fontWeights.bold,
		margin: 0,
	},
	subtitle: {
		color: THEME.colors.text.light,
		fontSize: fontSizes.sm,
		margin: 0,
	},
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[12],
	},
	sectionHeader: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[8],
	},
	sectionTitle: {
		fontFamily: fontFamilies.sora,
		fontSize: fontSizes.lg,
		fontWeight: fontWeights.bold,
		margin: 0,
	},
	grid: {
		display: 'grid',
		gap: SPACE[16],
		gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
		[THEME.queries.lg]: {
			gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
		},
		[THEME.queries.sm]: {
			gridTemplateColumns: 'minmax(0, 1fr)',
		},
	},
	card: {
		alignItems: 'center',
		backgroundColor: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		boxShadow: shadowSm,
		color: THEME.colors.text.main,
		display: 'flex',
		gap: SPACE[12],
		padding: SPACE[16],
		textDecoration: 'none',
		':hover': {
			borderColor: THEME.colors.border.main,
			boxShadow: shadow,
			color: THEME.colors.text.main,
			textDecoration: 'none',
		},
		':focus-visible': {
			outline: `2px solid ${THEME.colors.primary.main}`,
			outlineOffset: 2,
		},
	},
	iconTile: {
		alignItems: 'center',
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexShrink: 0,
		height: 40,
		justifyContent: 'center',
		width: 40,
	},
	icon: {
		height: 20,
		width: 20,
	},
	cardText: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		gap: SPACE[4],
		minWidth: 0,
	},
	cardName: {
		fontSize: fontSizes.sm,
		fontWeight: fontWeights.bold,
	},
	cardDescription: {
		color: THEME.colors.text.light,
		fontSize: fontSizes.xs,
	},
	externalIcon: {
		color: THEME.colors.text.light,
		flexShrink: 0,
		height: 16,
		width: 16,
	},
});

export const hueStyleSheet = StyleSheet.create({
	blue: { backgroundColor: THEME.colors.pill.blue.background, color: THEME.colors.pill.blue.icon },
	gray: { backgroundColor: THEME.colors.pill.gray.background, color: THEME.colors.pill.gray.icon },
	orange: { backgroundColor: THEME.colors.pill.orange.background, color: THEME.colors.pill.orange.icon },
	purple: { backgroundColor: THEME.colors.pill.purple.background, color: THEME.colors.pill.purple.icon },
	teal: { backgroundColor: THEME.colors.pill.teal.background, color: THEME.colors.pill.teal.icon },
});
